<template>
  <div>
    <RevButton
      v-if="!action.hint"
      :data-qa="`orderline-action-${action.type}`"
      :disabled="isButtonDisabled"
      full-width="always"
      :loading="isLoading"
      :variant
      @click="performAction"
    >
      {{ action.label }}
    </RevButton>

    <RevTooltip v-if="action.hint">
      <template #trigger="{ show, hide }">
        <RevButton
          :data-qa="`orderline-action-${action.type}`"
          :disabled="isButtonDisabled"
          full-width="always"
          :loading="isLoading"
          :variant
          @click="performAction"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        >
          {{ action.label }}
        </RevButton>
      </template>

      {{ action.hint }}
    </RevTooltip>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevButton } from '@ds/components/Button'
import { RevTooltip } from '@ds/components/Tooltip'

import type { Orderline } from '~/api/my-orders/types/OrderlineList.types'

import { useOrderlineCardActionsConfig } from '../../../composables/useOrderlineCardActionsConfig'

export interface OrderlineCardActionProps {
  loading?: boolean
  orderline: Orderline
  action: Orderline['actions'][number]
  variant: 'primary' | 'secondary'
}

const props = withDefaults(defineProps<OrderlineCardActionProps>(), {
  loading: false,
})

const { config: orderlineCardActionsConfig } = useOrderlineCardActionsConfig()

const config = computed(() =>
  orderlineCardActionsConfig[props.action.type](props.action),
)

const isLoading = computed(() => {
  return config.value.loading !== undefined
    ? config.value.loading
    : props.loading
})

const isButtonDisabled = computed(() => !props.action.active || isLoading.value)

async function performAction(): Promise<void> {
  if (config.value.onClick) {
    const { onClick } = config.value

    await onClick(props.orderline)
  }
}
</script>
